import styled from 'styled-components';
import { colors, layout } from 'Constants';
import { Container } from 'Components/core';

export default styled(Container).attrs(props => ({
  border: typeof props.border === 'boolean' ? props.border : true
}))`
  > * + * {
    ${props => props.border && `border-left: 0px solid ${colors.textDark}`}
   ;
  }

  > * {
      flex-basis: 100%;
  }

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    flex-direction: column;

    > * {
      flex-basis: auto;
      
    }

    > * + * {
      border-left: none;
    }
  }
`;
